import { render, staticRenderFns } from "./stars.vue?vue&type=template&id=01e905e5&scoped=true"
import script from "./stars.vue?vue&type=script&lang=js"
export * from "./stars.vue?vue&type=script&lang=js"
import style0 from "./stars.vue?vue&type=style&index=0&id=01e905e5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e905e5",
  null
  
)

export default component.exports